import React from 'react';
import { Route, Switch, Router } from 'react-router-dom';


import MapFrame from "../mapFrame";


export default () => (
    <Switch>

        <Route exact path="/map/:id" component={MapFrame} />
        <Route exact path="/map/:id/:riskPotential" component={MapFrame} />
    </Switch>
);